import React from 'react'
import { observer } from 'mobx-react'
import CompletionToggle from 'components/CompletionToggle'
import styles from './TaskCardTask.sass'
import { TaskListItemViewModel } from 'jobs/views/JobRoot/Job/MilestonesCard/Milestones/MilestonesViewModel'

interface TaskCardTaskProps {
  item: TaskListItemViewModel
}

export default observer(function TaskCardTask({ item }: TaskCardTaskProps) {
  const task = item.taskItem
  return (
    <div className={styles.item}>
      <div className={styles.info}>
        <p className={styles.title} title={task.title}>
          {task.title}
        </p>
        {task.description && (
          <p className={styles.description} title={task.description}>
            {task.description}
          </p>
        )}
      </div>
      <div className={styles.actions}>
        {item.canComplete && (
          <CompletionToggle
            completed={task.completed}
            onClick={item.toggleCompletion}
            size={32}
            readOnly={!item.canComplete}
            processing={item.toggleCompletion.pending}
            pulse={item.isNextIncompleteTask && item.canComplete}
            title={'Click to mark this task completed'}
            dataTest={`milestone-task-completion-toggle-${task.id}-new`}
          ></CompletionToggle>
        )}
      </div>
    </div>
  )
})
